import { defineMessages } from 'react-intl';

const messages = defineMessages({
  subscribeTitle: {
    id: 'Subscribe!',
    defaultMessage: 'Subscriu-te!',
  },
  subscribeSubtitle: {
    id: 'Subscribe to our newsletter subtitle',
    defaultMessage: 'I rebràs els nostres butlletins amb les últimes novetats!',
  },
  emailPlaceholder: {
    id: 'Email',
    defaultMessage: 'Email',
  },
  sending: {
    id: 'Sending...',
    defaultMessage: 'Enviant...',
  },
  send: {
    id: 'Send',
    defaultMessage: 'ENVIA',
  },
  privacyAccept: {
    id: 'I have read and accept the privacy policy',
    defaultMessage: 'He llegit i accepto la política de privacitat',
  },
  subscribeSuccess: {
    id: 'Subscription successful',
    defaultMessage: 'Subscripció realitzada amb èxit!',
  },
  subscribeError: {
    id: 'Subscription error',
    defaultMessage: 'Error al realitzar la subscripció.',
  },
  legalNotice: {
    id: 'Legal notice',
    defaultMessage: 'AVÍS LEGAL',
  },
  privacyPolicy: {
    id: 'Privacy policy',
    defaultMessage: 'POLÍTICA DE PRIVACITAT',
  },
  cookies: {
    id: 'Cookies',
    defaultMessage: 'COOKIES',
  },
  sitemap: {
    id: 'Sitemap',
    defaultMessage: 'MAPA WEB',
  },
  copyright: {
    id: 'Footer copyright',
    defaultMessage: 'CLÍNICA SANT JOSEP - ALTHAIA. TOTS ELS DRETS RESERVATS',
  },
  followUs: {
    id: 'Follow us on',
    defaultMessage: 'SEGUEIX-NOS A:',
  },
  scrollToTop: {
    id: 'Scroll to top',
    defaultMessage: 'Pujar amunt',
  },
  efqmLogoAlt: {
    id: 'EFQM certification logo alt',
    defaultMessage: 'Certificació EFQM',
  },
  smokeFreeLogoAlt: {
    id: 'Smoke free clinic logo alt',
    defaultMessage: 'La Clínica, lliure de fum',
  },
});

export default messages;
